import { withStyles } from "@material-ui/core/styles";
import ErrorBoundary from "error/ErrorBoundary";
import React from "react";
export default function withArtifex(HocComponent, styles) {
	function Hoc(props) {
		return (
			<ErrorBoundary location={props.location}>
				<HocComponent  {...props}></HocComponent>
			</ErrorBoundary>
		);
	}

	return withStyles(styles)(Hoc);
}